import React from 'react'
import { ThemeProvider } from '@emotion/react'
import CSSReset from '../styles/CSSReset'
import GlobalStyle from '../styles/GlobalStyle'
import ODXTheme from './theme'

export type ServiceName = 'odk' | 'odc' | 'odl'

interface Props {
  children: any
  theme: ServiceName
  resetCSS?: boolean
}

export default function ODXThemeProvider({ children, theme, resetCSS = true }: Props) {
  return (
    <ThemeProvider theme={ODXTheme[theme]}>
      {resetCSS && <CSSReset />}
      <GlobalStyle />
      {children}
    </ThemeProvider>
  )
}
